import React, { useState, useEffect, useContext } from "react";

import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  Checkbox,
  Card,
  CardContent,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ActionTypeTab from "./ActionTypeTab";
import {
  createActionMetric,
  fetchActionMetrics,
} from "../../../../redux/actions/metricActions";
import { useDispatch } from "react-redux";
import { DiscoveryContext } from "../../../BrandAudit/discovery-context";
import { AuthContext } from "../../../../context/auth-context";
import EmptyView from "../../../../Component/EmptyView/EmptyView";
import { getSourcesWithAlias } from "../../../../services/apiService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../../../../Component/Spinner/Spinner";
import { OVERVIEW_LLM_LABELS } from "../../../../utils/constant";
import { ENTITY_LABELS } from "../../../../utils/labelMapping";

export function dynamicReplace(text) {
  let result = text;

  const replacements = {
    "Visibility": ENTITY_LABELS.rank,
    'Brand Pillars': ENTITY_LABELS.brandPillar,
    'Brand_Pillars': ENTITY_LABELS.brandPillar,
    'Brand Pillar': ENTITY_LABELS.brandPillar,
    "Purchase Criteria": ENTITY_LABELS.purchaseCriteria,
    "Purchase_Criteria": ENTITY_LABELS.purchaseCriteria,
    "Product Dimension": ENTITY_LABELS.productDimension,
  };

  Object.keys(replacements).forEach((key) => {
    const regex = new RegExp(key, "gi"); // case-insensitive
    result = result.replace(regex, replacements[key]);
  });

  return result;
}

export const CommonInfoCard = ({ data, useCardWrapper = true }) => {
  const { brand, persona, llm, geography, category, market, isProduct } =
    data || {};

  // if (!useCardWrapper) {
  //   const category = [brand, llm, persona, market, geography]
  //     .filter(Boolean)
  //     .join(" | ");
  //   return <p style={{ fontSize: "15px", fontWeight: "bold" }}>{category}</p>;
  // }
  const case1 = [
    brand,
    category,
    OVERVIEW_LLM_LABELS?.[llm] || llm,
    persona,
    market,
    geography,
  ]
    .filter(Boolean)
    .join(" | ");
  return (
    <p
      style={{
        fontSize: !useCardWrapper ? "15px" : "20px",
        fontWeight: "bold",
      }}
    >
      {case1}
    </p>
  );

  // const InfoRow = ({ label, value }) => (
  //   <Grid item xs={4}>
  //     <Typography variant="body1" fontWeight="bold">
  //       {label}
  //     </Typography>
  //     <Typography variant="body2">{value || "N/A"}</Typography>
  //   </Grid>
  // );

  // return (
  //   <Card sx={{ mb: 2, boxShadow: 3, backgroundColor: "#4fd1c5" }}>
  //     <CardContent>
  //       <Grid container spacing={2}>
  //         <InfoRow label={isProduct ? "Product" : "Brand"} value={brand} />
  //         <InfoRow label="Persona" value={persona} />
  //         <InfoRow label="LLM" value={llm} />
  //         <InfoRow label="Geography" value={geography} />
  //         <InfoRow label="Market" value={market} />
  //       </Grid>
  //     </CardContent>
  //   </Card>
  // );
};

export const createDomainUrlMapping = (dataArray) => {
  const mapping = {};

  dataArray?.forEach((item) => {
    const domainUrl = item.domain_url;
    const aliasUrls = item?.source_aliases?.map((alias) => alias.url) || [];
    mapping[domainUrl] = aliasUrls;
  });

  return mapping;
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  maxHeight: "90vh",
  overflowY: "auto",
  borderRadius: "8px",
};

const ActionModal = ({ open, handleClose, data, type, sourceAliasIds }) => {
  const { user } = useContext(AuthContext);
  const customerId = user?.customer_id;
  const [actionType, setActionType] = useState(type);
  const [actionListItems, setActionListItems] = useState([]);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [visibleInfoCounts, setVisibleInfoCounts] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    setActionType(type);
  }, [type]);
  console.log("tabledata", data)
  const dataMapping = {
    reach: data?.Reach,
    sentiment: data?.Sentiment,
    risk: data?.Performance,
  };

  const discoveryCtx = useContext(DiscoveryContext);
  // Use the modal data context (llm/category/market) when checking propensity so mapping matches the item's source
  const opts = { llm: data?.llm, category: data?.category, market: data?.market };
  const isPropensity = discoveryCtx?.isPropensityToBuy?.(opts) ?? (discoveryCtx?.brand_scores?.rbiType === "propensityToBuy");
  const mapTitle = (t) => discoveryCtx?.mapMetricTitle?.(t, opts) ?? t;

  const maybeMap = (s) => {
    if (!s || typeof s !== "string") return s;
    return isPropensity ? mapTitle(s) : s;
  };

  const handleActionTypeChange = (key) => {
    setActionType(key);
  };

  const areArraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((val, index) => val === arr2[index]);
  };

  const handleCheckboxChange = (obj, checked) => {
    setActionListItems((prevItems) =>
      checked
        ? [...prevItems, obj]
        : prevItems.filter(
          (item) =>
            item.mainTitle !== obj.mainTitle ||
            !areArraysEqual(item.compTitles, obj.compTitles)
        )
    );
  };

  const isChecked = (obj) =>
    actionListItems.some(
      (item) =>
        item.mainTitle === obj.mainTitle &&
        areArraysEqual(item.compTitles, obj.compTitles)
    );

  const saveActions = async () => {
    const currentActions = [...actionListItems];
    if (!currentActions || currentActions.length === 0) return;
    setIsActionLoading(true);
    try {
      let sourceFullUrls = [];
      const sources = currentActions
        ?.map((obj) => obj.sources && obj.sources)
        .flat();
      if (sources && sources.length > 0) {
        sourceFullUrls = await getSourcesWithAlias({
          sources,
          sourceAliasIds: sourceAliasIds?.flat(),
        });
      }
      const domainUrlMapping = createDomainUrlMapping(sourceFullUrls?.data);
      const modifiedActionList = currentActions?.map((obj) => {
        const modifiedObj = {
          ...obj,
          brand: data?.brand,
          persona: data?.persona,
          geography: data?.geography,
          market: data?.market,
          llm: data?.llm,
          isProduct: data?.isProduct,
          sources: obj?.sources?.map((url) => {
            return { domain_url: url, fullUrl: domainUrlMapping?.[url] };
          }),
        };

        return modifiedObj;
      });

      const payload = {
        action_json: modifiedActionList,
        is_archived: 0,
        is_active: 1,
      };

      // Dispatch the createActionMetric and fetchActionMetrics
      dispatch(createActionMetric(customerId, payload))
        .then(() => {
          dispatch(fetchActionMetrics(customerId))
            .then(() => {
              toast.success("Action Added!", { autoClose: 700 });
            })
            .catch(() => {
              toast.error("Failed to fetch updated metrics!", {
                autoClose: 700,
              });
            });
        })
        .catch(() => {
          toast.error("Something went wrong while creating the action!", {
            autoClose: 700,
          });
        })
        .finally(() => {
          handleClose();
          setActionListItems([]);
          setIsActionLoading(false);
        });
    } catch (error) {
      handleClose();
      setActionListItems([]);
      setIsActionLoading(false);
      toast.error("Failed to fetch source URLs or process the action!", {
        autoClose: 700,
      });
    }
  };

  const handleLoadMore = (index) => {
    setVisibleInfoCounts((prev) => ({
      ...prev,
      [index]: (prev[index] || 5) + 5, // increase count for this accordion
    }));
  };


  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          setActionListItems([]);
          handleClose();
        }}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={style}>
          <IconButton
            id="close_id"
            onClick={() => {
              setActionListItems([]);
              handleClose();
            }}
            sx={{ position: "absolute", top: 8, right: 8, color: "gray" }}
          >
            <CloseIcon />
          </IconButton>

          {/* <ActionTypeTab
            activeTarget={actionType}
            handleChange={handleActionTypeChange}
          /> */}

          {dataMapping?.[actionType]?.length ? (
            <>
              <CommonInfoCard data={data} />
              <Typography variant="h6" component="div">
                Action Data Summary
              </Typography>
              <hr />

              <ul style={{ listStyleType: "square", paddingLeft: "20px" }}>
                {dataMapping?.[actionType]?.map((obj, index) => (
                  <React.Fragment key={index}>
                    {obj?.mainTitle &&
                      <li style={{}}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <Typography variant="body1" component="span">
                            {maybeMap(dynamicReplace(obj?.mainTitle))}
                          </Typography>
                          {/* <Checkbox
                          checked={isChecked(obj)}
                          onChange={(e) =>
                            handleCheckboxChange(obj, e.target.checked)
                          }
                        /> */}
                        </div>
                      </li>
                    }

                    {obj?.text &&
                      <li>
                        <Typography variant="body1" component="span">
                          {maybeMap(obj?.text)}
                        </Typography>
                      </li>
                    }

                    {obj?.compTitles?.map((item, subIndex) => (
                      item !== "" && (
                        <li key={`${index}-${subIndex}`}>
                          <Typography variant="body1" component="span">
                            {maybeMap(item)}
                          </Typography>
                        </li>
                      )
                    ))}

                    {
                      data?.llm?.toLowerCase().includes("search")
                      && <>  {obj?.sources && obj?.sources.length > 0 && (
                        <Typography
                          variant="h6"
                          component="div"
                          sx={{ mt: 2, ml: -2 }}
                        >
                          Sources
                        </Typography>
                      )}

                        {(() => {
                          const visibleCount = visibleInfoCounts[index] || 5;
                          const items = obj?.sources?.slice(0, visibleCount) || [];

                          return (
                            <>
                              {items.map((item, idx) => {
                                const displayValue = typeof item === "object" && item?.url ? item.url : item;
                                return (
                                  <li key={`${index}-source-${idx}`}>
                                    <Typography variant="body2">{displayValue}</Typography>
                                  </li>
                                );
                              })}


                              {visibleCount < obj?.sources?.length && (
                                <button
                                  style={{
                                    marginTop: "-20px",
                                    fontSize: "12px",
                                    color: "#1976d2",
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    marginLeft: '-5px'
                                  }}
                                  onClick={() => handleLoadMore(index)}
                                >
                                  Load More Sources..
                                </button>
                              )}
                            </>
                          );
                        })()}
                      </>}
                    <hr />
                  </React.Fragment>
                ))}
              </ul>

              {isActionLoading ? (
                <Spinner />
              ) : (
                // <Button
                //   disabled={!actionListItems || actionListItems.length === 0}
                //   variant="contained"
                //   color="primary"
                //   onClick={saveActions}
                //   sx={{ mt: 2 }}
                // >
                //   Add To Actions List
                // </Button>
                ""
              )}
            </>
          ) : (
            <EmptyView message="Nothing here" />
          )}
        </Box>
      </Modal>
      <ToastContainer />
    </>
  );
};

export default ActionModal;
